<template>
  <ul class="brand-style-2">
    <li v-for="(brand, i) in brandImages" :key="i">
      <a :href="brand.url">
        <img :src="brand.src" alt="Logo Images" />
      </a>
    </li>
  </ul>
</template>

<script>
  export default {
    data() {
      return {
        brandImages: [
          {
            src: require("../../assets/images/zhen/alaska.png"),
            url: "#",
          },
          {
            src: require("../../assets/images/zhen/bhi.png"),
            url: "#",
          },
          {
            src: require("../../assets/images/zhen/delmonte.png"),
            url: "#",
          },
          {
            src: require("../../assets/images/zhen/mayongs.png"),
            url: "#",
          },
          {
            src: require("../../assets/images/zhen/nestle.png"),
            url: "#",
          },
        ],
      };
    },
  };
</script>
